import actionsExport from "./actions";

export default {
  namespaced: true,
  actions: actionsExport,
};
